import React from 'react'

const FormError = ({children}) => {
  return (
    <div style={{color: "red", fontSize: "12px"}}>
      {children}
      {/* {message} */}
    </div>
  )
}

export default FormError
